.minus-svg {
  max-height: 1.5rem;
  max-width: 1.5rem;
  width: 1.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN2Zy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLm1pbnVzLXN2ZyB7XG4gIG1heC1oZWlnaHQ6IDEuNXJlbTtcbiAgbWF4LXdpZHRoOiAxLjVyZW07XG4gIHdpZHRoOiAxLjVyZW07XG59XG4iXX0= */